import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import Typing from '../Typing/Typing';
import * as Utils from '../../services/utils';
import {validation} from '../../services/validation';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp';
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import { ReactComponent as Submit } from '../../assets/images/submit.svg';

function CmpsCap({onComplete, onScroll, form, onShowInput}) {
  const [typing, setTyping] = useState(true);
  const [msg, setMsg] = useState(false);
  const [validInput, setValidInput] = useState(false);

  const send = (e) => {
    setMsg(form.getFieldValue("cap"));
    onComplete('step11');
  }

  const onInputChange = async () => {
    try {
      const values = await form.validateFields(['cap']);
      // Valid
      setValidInput(true);
    } catch (errorInfo) {
      // Not valid
      setValidInput(false);
    }
  };

  useEffect(() => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/cap');
    onShowInput(false);
    const timer = setTimeout(() => {
      setTyping(false);
      onShowInput(true);
      onScroll();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <section id="cmps-id">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300} last={true}>
              <span className="bubble">Da dove digiti? Scrivimi il CAP</span>
              <div className="info">
                <span className="time"><Timestamp /></span>
              </div>
            </CmpsAnimation>
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={600}>
            <div className="message">
              <span className="bubble">{msg}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
      <div className={`cmps_input ${!typing && !msg ? 'show' : ''}`} >
        <Form.Item 
          name="cap"
          rules={[
            { required: true, message: "richiesto" },
            { pattern: validation.cap.rule, message: validation.cap.message },
          ]}
        >
            <Input placeholder="Scrivi qui" autoComplete="off" type="number" maxLength={5} onChange={onInputChange} />
        </Form.Item>
        <Button className={['cmps_btn__send']} onClick={send} disabled={!validInput}>
          <Submit className="icon-cmps-submit" />
        </Button>
      </div>
    </section>
  );
  
} 

export default CmpsCap;